module.exports = __webpack_public_path__ + "static/flags/FI-2da4d09dd147d346636ed339913d4efc.gif";